import { createRouter, createWebHistory } from "vue-router"
import { getPayForOtherLogin } from '../api/api'
import bus from "./../lib/bus"
import { showToast } from "vant"
const routes = [
  { path: "/", redirect: '/gift' },
  { path: "/gift", component: () => import("../views/Gift.vue"), name: "GiftView", meta: { keepAlive: true } },
  { path: "/shop", component: () => import("../views/Shop.vue"), name: "ShopView", meta: { keepAlive: true } },
  { path: "/my", component: () => import("../views/My.vue") },
  { path: "/login", component: () => import("../components/LoginPage/LoginPage.vue") },
  { path: "/shop-rule", component: () => import("../views/ShopRule.vue") },
  { path: "/grow-rule", component: () => import("../views/GrowRule.vue") },
  { path: "/vip-rule", component: () => import("../views/VipRule.vue") },
  { path: "/shop-history", component: () => import("../views/ShopHistory.vue") },
  { path: "/grow", component: () => import("../views/Grow.vue") },
  { path: "/exchange-history", component: () => import("../views/ExchangeHistory.vue") },
  { path: "/customer-service", component: () => import("../views/CustomerService.vue") },
  { path: "/setting", component: () => import("../views/Setting.vue") },
  // sdk下载页面
  // { path: "/download", component: () => import("../views/DownloadPage.vue") },
  //sdk下载详情
  // { path: "/detail/:id", component: () => import("../views/DetailPage.vue") },
  // 充值详情内页
  // {
  //   path: "/pay",
  //   name: "paypage",
  //   component: () => import("../views/PayPage.vue"),
  //   meta: {
  //     keepAlive: true,
  //   },
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.query && to.query.token) {
    getPayForOtherLogin({
      token: to.query.token,
    }).then(res => {
      if (res.code === 200) {
        localStorage.setItem("token", res.data.access_token)
        localStorage.setItem("mobile", res.data.mobile)
        localStorage.setItem('otherData', JSON.stringify(res.data))
        bus.$emit("sendToken", res.data.access_token)
        bus.$emit('login', true)
        next({ path: to.path })
      } else {
        showToast(res.message)
        localStorage.removeItem("token")
        localStorage.removeItem("mobile")
        localStorage.removeItem('userInfo')
        next({ path: '/login' })
      }
    })
  } else {
    (!localStorage.getItem("token") && to.fullPath !== '/login') ?
      next({ path: '/login' }) :
      next()
  }
  // next()
})
export default router
